export const VideoLibraryCategories = [
  "Camera Moves",
  "Body Effects",
  "Scene Effects",
  "Supernatural",
  "Action Moves",
  "Cinematic Looks",
];

export const ImageLibraryCategories = [
  "Logo",
  "Nature",
  "People",
  "Poster",
  "Product",
  "T-shirt",
];
8;
export const VideoLibraryCategoryBgs = [
  "/images/InspireLibrary/cameraMoviesCategory.svg",
  "/images/InspireLibrary/bodyEffectsCategory.svg",
  "/images/InspireLibrary/sceneEffectsCategory.svg",
  "/images/InspireLibrary/supernaturalCategory.svg",
  "/images/InspireLibrary/actionMovesCategory.svg",
  "/images/InspireLibrary/cinematicLooksCategory.svg",
];

export const ImageLibraryCategoryBgs = [
  "/images/InspireLibrary/imgLogoCategory.svg",
  "/images/InspireLibrary/imgNatureCategory.svg",
  "/images/InspireLibrary/imgPeopleCategory.svg",
  "/images/InspireLibrary/imgPosterCategory.svg",
  "/images/InspireLibrary/imgProductCategory.svg",
  "/images/InspireLibrary/imgTshertCategory.svg",
];

export const InspirationLibraryApps = {
  imageLibrary: "Image Library",
  videoLibrary: "Video Library",
};

export const InspirationLibraryRoutes = {
  imageLibrary: "/library/image",
  videoLibrary: "/library/video",
};

export interface videoLibraryItem {
  prompt: string;
  category: number;
  fileName: string;
  url: string;
}
export interface ImageLibraryItem {
  prompt: string;
  category: number;
  fileName: string;
  url: string;
}
